import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async (data) => {
  return await dponetAPI.postForm('/monitoring_management_ncs', {
    monitoringManagementNc: data,
  })
}

const list = async (params) => {
  return await dponetAPI.get('/monitoring_management_ncs', { params })
}

const show = async ({ monitoringManagementNcId = '', ...params }) => {
  return await dponetAPI.get(
    `/monitoring_management_ncs/${monitoringManagementNcId}`,
    { params },
  )
}

const update = async ({ monitoringManagementNcId = '', ...params }) => {
  return await dponetAPI.put(
    `/monitoring_management_ncs/${monitoringManagementNcId}`,
    { monitoringManagementNc: params },
  )
}

const uploadAttachments = async ({
  monitoringManagementNcId = '',
  attachments,
}) => {
  return await dponetAPI.postForm(
    `/monitoring_management_ncs/${monitoringManagementNcId}/attachment`,
    { monitoringManagementNc: { attachments } },
  )
}

const destroyAttachment = async ({
  monitoringManagementNcId = '',
  attachmentId = '',
}) => {
  return await dponetAPI.delete(
    `/monitoring_management_ncs/${monitoringManagementNcId}/attachment/${attachmentId}`,
  )
}

export default {
  create,
  destroyAttachment,
  list,
  show,
  update,
  uploadAttachments,
}
